/**
 * AsyncComponent
 * Code Splitting Component / Server Side Rendering
 */
import React from "react";
import Loadable from "react-loadable"; 

// rct page loader
import RctPageLoader from "Components/RctPageLoader/RctPageLoader";

// ecommerce dashboard
const AsyncDashboardComponent = Loadable({
  loader: () =>
    import("../Dashboard/Dashboard"),
  loading: () => <RctPageLoader />
});


// Session Page 404
const AsyncSessionPage404Component = Loadable({
  loader: () => import("Routes/session/404"),
  loading: () => <RctPageLoader />
});
const AsyncSessionRootPage404Component = Loadable({
  loader: () => import("Routes/session/Root404"),
  loading: () => <RctPageLoader />
});

// Session Page 404
const AsyncSessionPage500Component = Loadable({
  loader: () => import("Routes/session/500"),
  loading: () => <RctPageLoader />
});

export {
  AsyncDashboardComponent,
  AsyncSessionPage404Component,
  AsyncSessionRootPage404Component,
  AsyncSessionPage500Component
};
